import React from 'react';

interface SectionGroupProps {
  title?: string;
  children: React.ReactNode;
  className?: string;
}

export function SectionGroup({ title, children, className = '' }: SectionGroupProps) {
  return (
    <div className={className}>
      {title && (
        // The label role: 12px semibold uppercase. Uppercase already reads
        // larger than its nominal size, and 12px is the documented label
        // floor, so this opens a clean 2px gap to the 14px tier below.
        // tracking-[0.04em] rather than tracking-wider (0.05em): Swedish
        // compounds like FÖREMÅLSDETALJER stretch badly at the looser value.
        <h3 className="text-[12px] leading-[16px] font-semibold text-[var(--text-tertiary)] uppercase tracking-[0.04em] px-4 mb-1.5">
          {title}
        </h3>
      )}
      <div className="bg-[var(--bg-surface)] rounded-ios-card overflow-hidden">
        {children}
      </div>
    </div>
  );
}
